import React, { memo, useCallback } from 'react';
import { Button, Dialog, SnackbarContent } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { YES, NO } from '../../../constants/strings';
import palette from '../../styles/palette';
import { View } from '../../Base';

const useStyles = makeStyles(() => ({
  modalRoot: {
    borderRadius: 0,
  },
  snackbarRoot: {
    borderRadius: 0,
    flexDirection: 'row',
  },
  snackbarMessage: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  iconWrap: {
    paddingRight: '0.8rem',
    display: 'flex',
  },
  button: {
    minWidth: 50,
    color: palette.snackbarButtons.yellow,
  },
}));

const ConfirmSnackbar = ({
  open,
  onConfirm,
  onClose,
  onConfirmDisable,
  children,
  messageIcon,
  trackConfirm,
  trackClose,
  confirmText = YES,
  declineText = NO,
  message,
  ...dialogProps
}) => {
  const classes = useStyles();

  const handleConfirm = useCallback(() => {
    onConfirm();
    trackConfirm && trackConfirm();
  }, [onConfirm, trackConfirm]);

  const handleClose = useCallback(() => {
    onClose();
    trackClose && trackClose();
  }, [onClose, trackClose]);

  return (
    <Dialog
      {...dialogProps}
      PaperProps={{ className: classes.modalRoot }}
      open={open}
      onClose={onClose}
    >
      <SnackbarContent
        className={classes.snackbarRoot}
        message={
          <>
            {messageIcon ? (
              <View className={classes.iconWrap}>{messageIcon}</View>
            ) : null}
            {message || children}
          </>
        }
        classes={{ message: classes.snackbarMessage }}
        action={[
          <Button
            key="yes"
            size="small"
            className={classes.button}
            onClick={handleConfirm}
            disabled={onConfirmDisable}
          >
            {confirmText}
          </Button>,
          <Button
            key="no"
            size="small"
            className={classes.button}
            onClick={handleClose}
          >
            {declineText}
          </Button>,
        ]}
      />
    </Dialog>
  );
};

export default memo(ConfirmSnackbar);
